import { useState, type FormEvent } from "react";
import { useNavigate } from "react-router-dom";

export function SearchBox({ initial = "", placeholder = "Search by vibe, brand, or tag…" }: { initial?: string; placeholder?: string }) {
  const [q, setQ] = useState(initial);
  const navigate = useNavigate();

  const onSubmit = (e: FormEvent) => {
    e.preventDefault();
    const query = q.trim();
    if (!query) return;
    navigate(`/search?q=${encodeURIComponent(query)}`);
  };

  return (
    <form className="searchbox" onSubmit={onSubmit}>
      <input
        type="search"
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={placeholder}
        aria-label="Search brands"
      />
      <button type="submit" className="primary">Search</button>
    </form>
  );
}
